import {tooltipData} from "../data/blogPost.data";

export default (node, props) => ({
  href: node?.hasAuthorPage && node.slug ? `/o-nas/${node.slug}` : null,
  name: `${node?.firstName} ${node?.lastName}`,
  fullName: `${node?.firstName} ${node?.lastName}`,
  role: node?.role,
  description: node?.description?.description,
  isVerified: props?.isVerified,
  ...(node?.href && {href: node.href}),
  isReversed: props?.isReversed,
  title: props?.title,
  picture: {
    src: node?.imageLarge?.url ? node.imageLarge?.url : node?.image?.url,
    alt: `${node?.firstName} ${node?.lastName} - ${node?.role}`
  },
  image: {
    src: node?.imageLarge?.url ? node.imageLarge?.url : node?.image?.url,
    alt: `${node?.firstName} ${node?.lastName} - ${node?.role}`
  },
  socials: {
    linkedin: node?.linkedin,
    muckrack: node?.muckrack
  },
  footerText: tooltipData.footerText
})
